/* Nessova ShoppingIL 4-8 Nov: hides the event pieces once it ends, and the sale popup. Content lives in snippets/nv-sil.liquid */
(function () {
  function ended(el) {
    return Date.now() > Date.parse(el.getAttribute('data-nv-sil-end'));
  }

  function hideEnded() {
    document.querySelectorAll('[data-nv-sil-end]').forEach(function (el) {
      if (ended(el)) el.style.display = 'none';
    });
  }

  // Sale popup: opens as soon as the page loads, once per visit, and waits behind another popup (Klaviyo) instead of stacking
  var POPUP_KEY = 'nvSilPopupSeen';

  function popupSeen() {
    try { return sessionStorage.getItem(POPUP_KEY) === '1'; } catch (e) { return true; }
  }

  function markPopupSeen() {
    try { sessionStorage.setItem(POPUP_KEY, '1'); } catch (e) {}
  }

  function otherDialogOpen() {
    return Array.prototype.some.call(document.querySelectorAll('[role="dialog"], [aria-modal="true"]'), function (el) {
      if (el.closest('.nv-sil-pop-wrap')) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
    }) || document.documentElement.classList.contains('lock-all');
  }

  function showPopup() {
    var tpl = document.getElementById('nv-sil-popup');
    if (!tpl || popupSeen()) return;

    var wrap = tpl.content.firstElementChild.cloneNode(true);
    if (ended(wrap)) return;
    if (otherDialogOpen()) {
      setTimeout(showPopup, 3000);
      return;
    }

    var lastFocus = document.activeElement;
    document.body.appendChild(wrap);
    markPopupSeen();
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    wrap.querySelector('.nv-sil-pop__cta').focus({ preventScroll: true });

    // If Klaviyo's popup opens on top, hide ours until it is closed, so the two never stack
    var watch = setInterval(function () {
      wrap.style.display = otherDialogOpen() ? 'none' : '';
    }, 500);

    function close() {
      clearInterval(watch);
      wrap.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { wrap.remove(); }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) close();
    });
    wrap.querySelectorAll('[data-nv-sil-pop-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', onKey);
  }

  function init() {
    hideEnded();
    setTimeout(showPopup, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
